import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getPendingSessionsEndpoint } from './pendingSessions.config';
import {
  PendingSession,
  PendingSessionsResponse,
} from './pendingSessions.types';

type PendingSessionsState = {
  isSessionsModalVisible: boolean;
  sessionsList: PendingSession[];
  updatedAt: number;
  totalSessionBalance: number;
  token: string;
};

const initialState: PendingSessionsState = {
  isSessionsModalVisible: false,
  sessionsList: [],
  updatedAt: 0,
  totalSessionBalance: 0,
  token: '',
};

const pendingSessionsReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === getPendingSessionsEndpoint) {
      const pendingSessionsData: PendingSessionsResponse =
        payload.response.data;

      if (pendingSessionsData) {
        state.updatedAt = pendingSessionsData.updatedAt;
        state.sessionsList = pendingSessionsData.pendingSessions;
        state.totalSessionBalance = pendingSessionsData.totalSessionBalance;
        state.token = pendingSessionsData.token;
      } else {
        state.updatedAt = 0;
        state.sessionsList = [];
        state.totalSessionBalance = 0;
        state.token = '';
      }
    }
  }),
);

export default pendingSessionsReducer;
